exports = module.exports = require("../../../../node_modules/_css-loader@0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".m-chatpanel-item.m-chatpanel-textlink .chat .body {\n  padding: 0px; }\n  .m-chatpanel-item.m-chatpanel-textlink .chat .body .textlink-body {\n    color: #202020;\n    padding: 10px 12px; }\n    .m-chatpanel-item.m-chatpanel-textlink .chat .body .textlink-body .textlink-text {\n      margin-top: 10px;\n      margin-bottom: 15px; }\n  .m-chatpanel-item.m-chatpanel-textlink .chat .body .textlink-link {\n    height: 42px;\n    background-color: #fff;\n    font-size: 12px;\n    color: #ff3d00;\n    text-align: center;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.25.0@css-loader??ref--3-1!./node_modules/_sass-loader@4.0.2@sass-loader??ref--3-2!./node_modules/_postcss-loader@1.3.3@postcss-loader??ref--3-3!./src/app/extension/textlink/style.scss
// module id = 371
// module chunks = 0 1